import React from 'react';

export const Required: React.FC = () => <span style={{ color: '#dc3545' }}>* </span>


